import { IMessage, Stomp } from "@stomp/stompjs";
import { readEnv } from "../readEnv";
import { CoreFrontendNotificationDto } from "@mm-products/java-multima-framework";
import { store } from "../redux/general/reduxStore";
import { addNotification, setChangedDocument, setCredit } from "../redux/userSlice";
import { addFeedback, feedbackDone } from "../redux/feedbackSlice";
import { TaxDocumentDto } from "../backend/taxguru";
import SockJS from "sockjs-client";
import { announceNewVersion } from "../components/NewVersionAnnounceComponent";
import { TaskNotificationType } from "../commonTypes";
import { createUpdateTask } from "../redux/taskSlice";

const devModeOn = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const logMessage = (message: IMessage) => {
    if (devModeOn) {
        console.debug(message);
    }
};

export const createWebSocketClient = () => {
    const serverUrl = readEnv("TAX_GURU_BACKEND_URL");
    if (!serverUrl) {
        throw new Error("TAX_GURU_BACKEND_URL not set");
    }
    const stompClient = Stomp.over(() => new SockJS(serverUrl.replaceAll(/\/$/g, "") + "/stomp"));

    const destinationForUser = (destination: string) => "/user" + destination;
    stompClient.configure({
        reconnectDelay: 3000,
        onConnect: () => {
            stompClient.subscribe(destinationForUser("/specific/notification"), (message) => {
                const msg: CoreFrontendNotificationDto = JSON.parse(message.body);
                logMessage(message);
                store.dispatch(addNotification(msg));
            });
            stompClient.subscribe(destinationForUser("/specific/taskProgress"), (message) => {
                const taskNotification: TaskNotificationType = JSON.parse(message.body);
                logMessage(message);
                store.dispatch(createUpdateTask(taskNotification));
            });
            stompClient.subscribe(destinationForUser("/specific/credit"), (message) => {
                logMessage(message);
                store.dispatch(setCredit(parseFloat(message.body)));
            });
            stompClient.subscribe(destinationForUser("/specific/document/changed"), (message) => {
                const documentDto: TaxDocumentDto = JSON.parse(message.body);
                logMessage(message);
                store.dispatch(setChangedDocument(documentDto));
            });
            stompClient.subscribe("/all/newVersion", (message) => {
                logMessage(message);
                announceNewVersion(JSON.parse(message.body));
            });
            stompClient.subscribe(destinationForUser("/specific/user-feedback/show"), (message) => {
                logMessage(message);
                store.dispatch(addFeedback(JSON.parse(message.body)));
            });
            stompClient.subscribe(destinationForUser("/specific/user-feedback/done"), (message) => {
                logMessage(message);
                store.dispatch(feedbackDone(JSON.parse(message.body)));
            });
        },
        // Helps during debugging, remove in production
        debug: (str) => {
            if (devModeOn) {
                console.debug(new Date(), str);
            }
        },
    });
    return stompClient;
};
